import { findModuleExport } from '../webpack';
/** @component React Components */
export const Field = findModuleExport((e) => e?.render?.toString().includes('"shift-children-below"'));
